import { observer } from 'mobx-react-lite'

import { dmsState } from '@/app/store'
import { paginationTopList, type InputEvent } from '@/pages/Dms/helper'

import Broom from './brrom.svg'
import { DatesRange } from './DatesRange/DatesRange'
import style from './Filters.module.scss'
import { InputFilter } from './InputFilter/InputFilter'
import { MarkersFilter } from './MarkersFilter/MarkersFilter'
import { useFilterFields } from './useFilterFields'

export const Filters = observer(() => {
    const { onChangeInsuranceCompanyId } = useFilterFields()

    const onZeroFilters = () => {
        dmsState.onResetInsuredsFilters()
        dmsState.onGetInsuredsList()
        onChangeInsuranceCompanyId(null)
    }

    const onGetInsuredsListHandler = () => {
        dmsState.onSetInsuredFilters({ ...dmsState.insuredFilters, skip: 0, top: paginationTopList, totalCount: 0 })
        dmsState.onGetInsuredsList()
    }

    const onSearchByFio = (e: InputEvent) => {
        dmsState.onSetInsuredFilters({ ...dmsState.insuredFilters, insuredFio: e.target.value })
    }

    const onSearchByPolisNumber = (e: InputEvent) => {
        dmsState.onSetInsuredFilters({ ...dmsState.insuredFilters, insuredPolisNumber: e.target.value })
    }

    const onSearchByExpirationStartDate = (date: string | null) => {
        dmsState.onSetInsuredFilters({
            ...dmsState.insuredFilters,
            expirationDates: { ...dmsState.insuredFilters.expirationDates, startDate: date }
        })
    }

    const onSearchByExpirationEndDate = (date: string | null) => {
        dmsState.onSetInsuredFilters({
            ...dmsState.insuredFilters,
            expirationDates: { ...dmsState.insuredFilters.expirationDates, endDate: date }
        })
    }

    const onSearchByIncuranceCompanyName = (e: InputEvent) => {
        dmsState.onSetInsuredFilters({ ...dmsState.insuredFilters, insuranceCompanyName: e.target.value })
    }
    return (
        <div className={style.container}>
            <div className={style.filters}>
                <MarkersFilter
                    insuredFilters={dmsState.insuredFilters}
                    placeholder='Выбор цветов'
                    options={dmsState.guideMarkers}
                    classname={style.item1}
                    onSetInsuredsFilters={dmsState.onSetInsuredFilters}
                    onGetInsuredsList={onGetInsuredsListHandler}
                />
                <InputFilter
                    value={dmsState.insuredFilters.insuredPolisNumber}
                    placeholder='Поиск по номеру полиса'
                    classname={style.item2}
                    onChange={onSearchByPolisNumber}
                    onGetInsuredsList={onGetInsuredsListHandler}
                />
                <DatesRange
                    classname={style.item3}
                    startDate={dmsState.insuredFilters.expirationDates.startDate}
                    endDate={dmsState.insuredFilters.expirationDates.endDate}
                    onSetStartDate={onSearchByExpirationStartDate}
                    onSetEndDate={onSearchByExpirationEndDate}
                    onGetInsuredsList={onGetInsuredsListHandler}
                />
                <InputFilter
                    value={dmsState.insuredFilters.insuredFio}
                    placeholder='Поиск по ФИО'
                    classname={style.item4}
                    onChange={onSearchByFio}
                    onGetInsuredsList={onGetInsuredsListHandler}
                />
                <InputFilter
                    value={dmsState.insuredFilters.insuranceCompanyName}
                    placeholder='Поиск по страховой компании'
                    classname={style.item5}
                    onChange={onSearchByIncuranceCompanyName}
                    onGetInsuredsList={onGetInsuredsListHandler}
                />
                <div className={style.controls}>
                    <button title='Сброс фильтрации' onClick={onZeroFilters}>
                        <Broom />
                    </button>
                </div>
            </div>
        </div>
    )
})
